import { FormControlLabel, Grid, Radio, RadioGroup } from "@mui/material";
import { FormikProps } from "formik";
import Flex from "../../../../../../../../../../../../components/Flex";
import Text from "../../../../../../../../../../../../components/Text";
import StyledButtonV2 from "../../../../../../../../../../../../components/app/StyledButtonV2";
import StyledFormModal from "../../../../../../../../../../../../components/globalModal/StyledModal";
import { DisclosureHost } from "../../../../../../../../../../../../hooks/use-disclosure";
import useFormDraft from "../../../../../../../../../../../../hooks/use-form-draft";
import { Form2Payload } from "../../../../../../../../../scheduling/appointment/encounter/encounter-constant";
import {
  BIRP_PROGRESS_FIELDS,
  BIRP_PROGRESS_OPTIONS,
} from "../BirpNoteConstant";

interface ProgressModalProps {
  disclosureHost: DisclosureHost;
  formik: FormikProps<Form2Payload>;
}

/**
 * Response → Progress. Single select, so it follows the Risk Assessment modal's
 * radio-group flow rather than the checkbox-card one.
 */
const ProgressModal = ({ disclosureHost, formik }: ProgressModalProps) => {
  // Edits stay in the draft until Save, so the note behind the modal is
  // untouched while the user is still filling it in.
  const draft = useFormDraft(
    formik,
    BIRP_PROGRESS_FIELDS,
    disclosureHost.opened
  );

  return (
    <StyledFormModal
      open={disclosureHost.opened}
      onClose={() => disclosureHost.close()}
      dialogTitle="Progress"
      dialogAction={
        <>
          <StyledButtonV2
            label="Cancel"
            variant="outlined"
            onClick={() => disclosureHost.close()}
          />
          <StyledButtonV2
            label="Save"
            variant="contained"
            onClick={() => {
              draft.save();
              disclosureHost.close();
            }}
            sx={{ width: "105px" }}
          />
        </>
      }
      sx={{
        "& .MuiDialog-paper": {
          width: "50vw",
          height: "50vh",
        },
      }}
    >
      <Flex flexDirection="column" gap={2} pt={2}>
        <Text variant="subtitle1" fontWeight="500">
          Select Progress:
        </Text>

        <RadioGroup
          name="progress"
          value={draft.values.progress ?? ""}
          onChange={(_, value) => draft.setFieldValue("progress", value)}
        >
          <Grid container spacing={1}>
            {BIRP_PROGRESS_OPTIONS.map((option) => (
              <Grid key={option.value} size={12}>
                <FormControlLabel
                  value={option.value}
                  control={<Radio />}
                  sx={{ alignItems: "center" }}
                  label={
                    <Text fontSize="14px" fontWeight="500">
                      {option.label}
                    </Text>
                  }
                />
              </Grid>
            ))}
          </Grid>
        </RadioGroup>
      </Flex>
    </StyledFormModal>
  );
};

export default ProgressModal;
